<template>
  <header>
    <span class="logo" @click="onLogoClick">
      <img
        class="logo-image color"
        :class="{ 'is-active': !isWhite }"
        src="@/assets/trico-logo.svg"
        alt=""
      />
      <img
        class="logo-image white"
        :class="{ 'is-active': isWhite }"
        src="@/assets/trico-logo-wh.svg"
        alt=""
      />
    </span>
  </header>
</template>

<script>
import smoothscroll from 'smoothscroll-polyfill'

export default {
  computed: {
    isWhite() {
      const color = this.$store.state.logoColor
      return color === 'white'
    }
  },

  created() {
    smoothscroll.polyfill()
  },

  methods: {
    async onLogoClick() {
      if (this.$route.name !== 'home') {
        const { dispatch } = this.$store
        dispatch('debounceRouterPush', '/')
      } else {
        if (window.lmS) {
          window.lmS.scrollTo(0)
        } else {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  position: absolute;
  top: 0;
  left: 0;
  padding: 2.2rem;
  z-index: 99;
  @media screen and (max-width: $breakpoint-mobile) {
    position: fixed;
    padding: 1.3rem;
  }

  .logo {
    position: relative;
    display: block;
    width: 30rem;
    height: 3.5rem;
    cursor: pointer;
    @media screen and (max-width: $breakpoint-mobile) {
      width: 22rem;
      height: 3rem;
    }

    .logo-image {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;

      &.is-active {
        opacity: 1;
      }
    }
  }
}
</style>
